"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Tag = exports.Tag = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    textId,
    textValues = {},
    color,
    dataCy = 'exactMatch',
    className = '',
    style,
    icon,
    classNameOverrides
  } = {
    ...(props || {})
  };
  return /*#__PURE__*/_react.default.createElement("span", {
    ref: ref,
    role: "heading",
    "aria-level": "3",
    "data-testid": dataCy,
    "data-cy": dataCy,
    style: style,
    className: (0, _classnames.default)('font-weight-bold text-uppercase py-1 rounded letter-spacing-pt9', color, className, {
      'd-inline-flex': Boolean(icon) && !classNameOverrides?.overrideDisplayInlineFlex,
      'px-2': Boolean(textId) && color,
      'px-1': !textId && color,
      'align-items-start': !icon,
      'align-items-center': Boolean(icon)
    })
  }, icon, textId && /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: textId,
    values: textValues
  }));
});
Tag.propTypes = {
  textId: _propTypes.default.string.isRequired,
  textValues: _propTypes.default.object,
  color: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  icon: _propTypes.default.node,
  classNameOverrides: _propTypes.default.shape({
    overrideDisplayInlineFlex: _propTypes.default.bool
  })
};